import React, { Suspense, lazy } from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import FloatingWhatsapp from "./components/FloatingWhatsapp";
import { ShopContextProvider } from "./context/shop-context";

// Lazy load components
const Landing = lazy(() => import('./components/Landing'));
const RoyalMenu = lazy(() => import('./components/RoyalMenu'));
const BookTable = lazy(() => import('./components/BookTable'));
const Location = lazy(() => import('./components/Location'));
const Gallery = lazy(() => import('./components/Gallery'));
const About = lazy(() => import('./components/About'));
const Contact = lazy(() => import('./components/Contact'));
const Cart = lazy(() => import('./cart/Cart').then(module => ({ default: module.Cart })));

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-[#050f0d]">
    <div className="w-16 h-16 border-4 border-[#d4af37] border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <div className="App">
      <ShopContextProvider>
        <FloatingWhatsapp />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path='/' exact element={<Landing />} />
            <Route path='/menu' exact element={<RoyalMenu />} />
            <Route path='/book-table' exact element={<BookTable />} />
            <Route path='/location' exact element={<Location />} />
            <Route path='/gallery' exact element={<Gallery />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/cart' element={<Cart />} />
          </Routes>
        </Suspense>
      </ShopContextProvider>
    </div>
  );
}

export default App;
